import React from 'react';
import FooterLogo from '../../../assests/images/footer_logo.png';

export const Footer = () => {

  return (
    <div className="footer">
      <div className="fl-left" style={{ marginLeft: '5%' }}>
        <div className="width-100">
          <div
            style={{ marginBottom: '12px' }}
            className="fl-left ml-left-5 fl-size-11"
          >
            Music by
          </div>
        </div>
        <div style={{ marginTop: '-9px' }}>
          <img
            className="footer-img"
            src={FooterLogo}
            alt="powered by Epidemic"
          />
          <div className="fl-left fl-size-15">Epidemic Sound</div>
        </div>
      </div>
      <div className="fl-right" style={{ marginRight: '5%' }}>
        <button className="fl-right ml-right-5 get-more">
          <a
            className={'get-more'}
            style={{ textDecoration: 'none' }}
            target="_blank"
            href="https://www.epidemicsound.com/?utm_source=vlogr&utm_medium=partner&utm_campaign=&_us=partner&_usx=vlogr"
          >
            Get More
          </a>
        </button>
      </div>
    </div>
  );
};
